import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img 
                src="/logos/TB Construction_Logo_FINAL-OL_Logo Mark_Rt_White TB.png" 
                alt="TB Construction" 
                className="footer-logo-image"
              />
            </Link>
            <p className="footer-description">
              Over 30 years of experience developing sites from residential to commercial applications in the Greater Boston Area.
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Services</h3>
            <ul>
              <li><Link to="/services/site-clearing">Site Clearing</Link></li>
              <li><Link to="/services/excavation">Excavation</Link></li>
              <li><Link to="/services/grading">Grading</Link></li>
              <li><Link to="/services/foundation">Foundation</Link></li>
              <li><Link to="/services/backfilling">Backfilling</Link></li>
              <li><Link to="/services/screening-processing">Screening & Processing</Link></li>
              <li><Link to="/services/landscaping">Landscaping</Link></li>
              <li><Link to="/services/irrigation">Irrigation Services</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <p>Greater Boston Area</p>
            <p><a href="tel:6174126800">(617) 412-6800</a></p>
            <p><a href="mailto:info@tbconstructionco.com">info@tbconstructionco.com</a></p>
            <a href="/contact" className="footer-cta">Get Your Proposal</a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TB Construction. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

